import React from "react";
import { Redirect } from 'react-router-dom';
import CheckoutStep from './../Checkout/CheckoutStep.jsx';
import SumInfo from './../Checkout/SumInfo.jsx';
import { CheckoutProvider } from './../Providers/CheckoutProvider'
import CheckoutUserForm from './../Forms/CheckoutUserForm.jsx'
import { Storage } from './../Core/Storage';
import { Customer } from './../Models/Customer';
import { Contact } from './../Models/Contact';
import { Routes } from './../Core/Constants';
import CheckoutCross from "./CheckoutCross.jsx";
import { UserProvider } from './../Providers/UserProvider';
import { AppStore } from './../Core/AppStore'


export default class CheckoutUser extends React.Component {
    state = {
        pricedOrder: null,
        redirectToContinue: false,
        cross: !Storage.instance().isAuthorized() && !Storage.instance().isSegmentUser(),
        redirect: {
            url: Routes.CheckoutFinish,
            postData: null
        },
        customer: null,
        submiting: false,
        placingOrder: false
    }

    componentDidMount = () => {

        AppStore.emit('Checkout.Header', true);
        var that = this;
        if (window.gtm) {
            window.gtm.loaded = false;
        }
        var customer = Storage.instance().customer;
        if (!Storage.instance().isAuthorized()) {
            if (customer == null) {
                customer = new Customer();
            }
            customer = this.prepareCustomer(customer, '');
        }
        else {
            customer = UserProvider.getUser((data) => {
                Storage.instance().customer = data;
                customer = new Customer();
                customer.invoiceContact = data.invoiceContact;
                customer.deliveryContact = data.deliveryContact;
                let email = (data.username.indexOf('@') > 0) ? data.username : '';
                customer = this.prepareCustomer(customer, email);

                that.setState({
                    customer: customer
                });
            })
            if (!customer) {
                customer = new Customer();
                customer = this.prepareCustomer(customer, '');

            }
        }
            CheckoutProvider.calculate((data) => {
                window.gtm.loadCheckoutUser(data);
                if (data.cartedProducts.length == 0)
                    this.setState({ redirect: { url: Routes.Cart }, redirectToContinue: true });
                that.setState({
                    pricedOrder: data,
                    customer: customer
                });

            });
        }

        prepareCustomer = (customer, email) => {
            if (!customer.invoiceContact) {
                customer.invoiceContact = new Contact;
                customer.invoiceContact.email = email;
            }
            if (!customer.deliveryContact) {
                customer.deliveryContact = new Contact();
                customer.deliveryContact.isDeliveryContact = false;
            }
            return customer;
        }


        isEmptyAuthorizedUser = () => {
            return Storage.instance().isAuthorized() && Storage.instance().customer != null && Storage.instance().customer.invoiceContact == null;
        }


        handleUnregistered = () => {
            this.setState({
                cross: false
            });
        }

        handleSubmit = (values, setSubmiting, saveContactTo) => {
            this.setState({ submiting: true });
            let model = values;
            if (!model.deliveryContact.isDeliveryContact) {
                delete model.deliveryContact;
            }

            if (Storage.instance().isAuthorized() && Storage.instance().customer != null && saveContactTo == Storage.instance().customer.username) {
                var customerToUpdate = Storage.instance().customer;
                customerToUpdate.invoiceContact = model.invoiceContact;
                delete customerToUpdate.deliveryContact;

                UserProvider.updateUser(customerToUpdate, () => {
                    this.placeOrder(model, setSubmiting);
                }, (err) => {
                    this.placeOrder(model, setSubmiting);//uložim objednávku i když se nepodaří zaktuaizovat zákazníka
                });
            }
            else {
                this.placeOrder(model, setSubmiting);
            }

        }

        placeOrder = (customer, setSubmiting) => {


            Storage.instance().customer = customer;
            CheckoutProvider.placeOrder(this.state.pricedOrder.priceTable.totalPriceExclVat, () => {
                this.setState({ redirect: { url: Routes.CheckoutFinish }, redirectToContinue: true });
                setSubmiting(false);

            },
                (err) => {
                    if (Array.isArray(err.responseJSON) && err.responseJSON.length) {
                        err.responseJSON.map(resp => {
                            if (Array.isArray(resp.entityErrors) && resp.entityErrors.length) {
                                resp.entityErrors.map(entErr => alert(entErr.msg));
                            }
                        });
                    }
                    else {
                        alert(err.responseText
);
                    }
                    setSubmiting(false);
                    this.setState({ submiting: false, placingOrder: false });
                });
            this.setState({ placingOrder: true });
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        render = () => {
            if (this.state.cross) {
                return (<CheckoutCross goUnregistered={() => this.handleUnregistered()} />);
            }

            let T = window.Texts.checkout;
            if (this.state.redirectToContinue) {
                return (<Redirect to={this.state.redirect.url} />);
            }

            let customer = this.state.customer;
            if (customer && !customer.remarks)
                customer.remarks = '';
            let cart = Storage.instance().cart;
            if (!cart || !cart.cartedProducts || cart.cartedProducts.length == 0)
                return (<Redirect to={Routes.Cart} />);

            let pricedOrder = this.state.pricedOrder;
            if (!pricedOrder || !customer)
                return T.loading;


            if (this.state.placingOrder) {
                return (
                    <div className="checkout-page">
                        <div className="cover">
                            <div className="headline">
                                <h1>{T.sendingFull}</h1>
                            </div>
                        </div>
                    </div>)
            }


            return (
                <div className="checkout-page">
                    <div className="cover">
                        <CheckoutStep Step="2" />
                        <div className="checkout-inner">
                            <div className="page-delivery-payment">
                                <div className="headline">
                                    <h1>{T.yourData}</h1>
                                </div>
                                <div className="prow">
                                    <div className="pcol delivery-pament span-6">
                                        <CheckoutUserForm
                                            initValues={customer}
                                            onSubmit={(values, setSubmiting, saveContactTo) => this.handleSubmit(values, setSubmiting, saveContactTo)}
                                            saveContactTo={(this.isEmptyAuthorizedUser()) ? Storage.instance().customer.username : ''}
                                            isLoading={this.state.submiting}
                                            loadingText={T.sending} />
                                    </div>
                                    <SumInfo pricedOrder={pricedOrder} />
                                </div>
                            </div>
                            <p className="xo-vraceckaInfo">
                                {T.tradeConditions}&nbsp;
                                <a href={Routes.TradeTerms} tagret="_blank"><u>{T.tradeTerms}</u></a>
                            </p>
                        </div>
                    </div>
                </div>
            );
        }
    }
